import {Ipoint3D} from "../../../../common/interfaces";
export const WifiboxNG: Ipoint3D[] = [
    {
        id: 1,
        img: null,
        imgArray: null,
        posX: -0.2,
        posY: 5,
        posZ: 2.8,
        shortTitle: "Антена",
        title: "Антена",
        text: "Беспроводное WiFi соединение с ПК",
        points: null
    },
    {
        id: 2,
        img: null,
        imgArray: null,
        posX: 4.2,
        posY: 0,
        posZ: 0,
        shortTitle: "Разьем зарядки",
        title: "Разьем зарядки",
        text: "Разъем для зарядки устройств",
        points: null
    },
    {
        id: 3,
        img: null,
        imgArray: null,
        posX: 5.2,
        posY: -22,
        posZ: 4,
        shortTitle: "Корпус",
        title: "Корпус",
        text: "Ударопрочный корпус",
        points: null
    },
    {
        id: 4,
        img: null,
        imgArray: null,
        posX: -2.9,
        posY: 0,
        posZ: 0,
        shortTitle: "Разъем датчика",
        title: "Разъем датчика",
        text: "Разъем для подключения датчика вибрации Pulse NG",
        points: null
    },

];
export const IBUNG: Ipoint3D[] = [
    {
        id: 1,
        img: null,
        imgArray: null,
        posX: 1.3,
        posY: 2,
        posZ: 11,
        shortTitle: "Питание",
        title: "Питание",
        text: "Питание 24В",
        points: null
    },
    {
        id: 2,
        img: null,
        imgArray: null,
        posX: 1,
        posY: -2,
        posZ: 11,
        shortTitle: "Интерфейс обратной связи",
        title: "Интерфейс обратной связи",
        text: "Интерфейс обратной связи с ЧПУ (5DO/5DI)",
        points: null
    },
    {
        id: 3,
        img: null,
        imgArray: null,
        posX: 1,
        posY: -8,
        posZ: 11,
        shortTitle: "Порт RJ-45",
        title: "Порт RJ-45",
        text: "Порт RJ-45 для соединение c ПК или локальной сетью",
        points: null
    },
    {
        id: 4,
        img: null,
        imgArray: null,
        posX: -1.9,
        posY: -11.3,
        posZ: 12,
        shortTitle: "Разъем сенсоров",
        title: "Разъем сенсоров",
        text: "Разъем подключения сенсоров",
        points: null
    },
    {
        id: 5,
        img: null,
        imgArray: null,
        posX: 0,
        posY: -2,
        posZ: -12,
        shortTitle: "Крепление",
        title: "Крепление",
        text: "Крепление на DIN рейку",
        points: null
    },

];
export const PulseNG: Ipoint3D[] = [
    {
        id: 1,
        img: null,
        imgArray: null,
        posX: -17,
        posY: 3,
        posZ: -2.5,
        shortTitle: "Резьбовое соединение",
        title: "Резьбовое соединение",
        text: "Резьбовое герметичное соединение с блоком IBU NG",
        points: null
    },
    {
        id: 2,
        img: null,
        imgArray: null,
        posX: -8,
        posY: 1.3,
        posZ: 0.1,
        shortTitle: "Кабель",
        title: "Кабель",
        text: "Износостойкий кабель",
        points: null
    },
    {
        id: 3,
        img: null,
        imgArray: null,
        posX: 3,
        posY: -2,
        posZ: 4,
        shortTitle: "Крепление",
        title: "Крепление",
        text: "Надежное крепление на неодимовых магнитах",
        points: null
    },
    {
        id: 4,
        img: null,
        imgArray: null,
        posX: -2.5,
        posY: 2,
        posZ: 1,
        shortTitle: "Датчик",
        title: "Датчик",
        text: "Трех осевой датчик вибрации",
        points: null
    }

];
export const Baumer: Ipoint3D[] = [
    {
        id: 1,
        img: null,
        imgArray: null,
        posX: 7,
        posY: 0,
        posZ: 0.1,
        shortTitle: "Тензорезистивный датчик",
        title: "Тензорезистивный датчик",
        text: "Тензорезистивный датчик усилия",
        points: null
    },
    {
        id: 2,
        img: null,
        imgArray: null,
        posX: -5.5,
        posY: 2.5,
        posZ: 0.1,
        shortTitle: "Корпус",
        title: "Корпус",
        text: "Корпус из никелированной стали",
        points: null
    }
];
export const SpectraNG: Ipoint3D[] = [
    {
        id: 1,
        img: null,
        imgArray: null,
        posX: -2,
        posY: 4.8,
        posZ: 17,
        shortTitle: "Питание",
        title: "Питание",
        text: "Порт RJ-45 для соединения с ПК или локальной сетью",
        points: null
    },
    {
        id: 2,
        img: null,
        imgArray: null,
        posX: -3.3,
        posY: 2.5,
        posZ: 17,
        shortTitle: "Интерфейс обратной связи",
        title: "Интерфейс обратной связи",
        text: "Разъем подключения сенсоров",
        points: null
    },
    {
        id: 3,
        img: null,
        imgArray: null,
        posX: 5,
        posY: -3.2,
        posZ: 16,
        shortTitle: "Порт RJ-45",
        title: "Порт RJ-45",
        text: "Интерфейс обратной связи с ЧПУ",
        points: null
    },
    {
        id: 4,
        img: null,
        imgArray: null,
        posX: -6,
        posY: -3.5,
        posZ: 16,
        shortTitle: "Разъем сенсоров",
        title: "Разъем сенсоров",
        text: "Подключение SensorHUB",
        points: null
    },
    {
        id: 5,
        img: null,
        imgArray: null,
        posX: 2,
        posY: -6.9,
        posZ: 16,
        shortTitle: "Разъем сенсоров",
        title: "Разъем сенсоров",
        text: "Возможность подлючения монитора для Spectra HMI",
        points: null
    },
    {
        id: 6,
        img: null,
        imgArray: null,
        posX: -1.3,
        posY: -9.9,
        posZ: 16,
        shortTitle: "Разъем сенсоров",
        title: "Разъем сенсоров",
        text: "Profinet  и Profibus интерфейсы",
        points: null
    },
    {
        id: 7,
        img: null,
        imgArray: null,
        posX: 5.3,
        posY: -13,
        posZ: 16,
        shortTitle: "Разъем сенсоров",
        title: "Разъем сенсоров",
        text: "Питание 24 В",
        points: null
    },

];

